<!-- @author zhengjie -->
<template>
  <div class="icon-body">
    <el-input v-model="name" style="position: relative;" clearable placeholder="请输入图标名称" @clear="filterIcons" @input.native="filterIcons">
      <i slot="suffix" class="el-icon-search el-input__icon" />
    </el-input>
    <div class="icon-list">
      <div v-for="(item, index) in iconList" :key="index" @click="selectedIcon(item)">
        <svg-icon v-if="!item.includes('el-icon')" :icon-class="item" style="height: 30px;width: 16px;margin-right:10px;" />
        <i v-if="item.includes('el-icon')" :class="[item, 'sub-el-icon']" />
        <span>{{ item }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import elNames from './iconNames'
import icons from './requireIcons'
// console.log(elNames,icons)
export default {
  name: 'IconSelect',
  data() {
    return {
      name: '',
      iconList: [...icons, ...elNames]
    }
  },
  methods: {
    filterIcons() {
      this.iconList = [...icons, ...elNames]
      if (this.name) {
        this.iconList = this.iconList.filter(item => item.includes(this.name))
      }
    },
    selectedIcon(name) {
      this.$emit('selected', name)
      document.body.click()
    },
    reset() {
      this.name = ''
      this.iconList = [...icons, ...elNames]
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .icon-body {
    width: 100%;
    padding: 10px;
    .icon-list {
      height: 200px;
      overflow-y: scroll;
      div {
        height: 30px;
        line-height: 30px;
        margin-bottom: -5px;
        cursor: pointer;
        width: 33%;
        float: left;
      }
      i{
        font-size: 20px;
        margin-right: 10px;
      }
      span {
        display: inline-block;
        vertical-align: -0.15em;
        fill: currentColor;
        overflow: hidden;
      }
    }
  }
</style>
